import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  inject,
  signal,
} from '@angular/core';

@Component({
  selector: 'app-marketing-popup',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (visible()) {
      <div class="cg-mkt-popup" role="dialog" aria-modal="true" aria-label="Promotion">
        <button
          type="button"
          class="cg-mkt-popup__backdrop"
          aria-label="Close popup"
          (click)="dismiss()"
        ></button>
        <div class="cg-mkt-popup__panel">
          <button type="button" class="cg-mkt-popup__close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
          </button>
          <img class="cg-mkt-popup__img" [src]="imageUrl" [alt]="imageAlt || 'Promotion'" />
        </div>
      </div>
    }
  `,
})
export class MarketingPopupComponent implements OnInit, OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  private timer?: ReturnType<typeof setTimeout>;

  @Input({ required: true }) imageUrl!: string;
  @Input() imageAlt?: string;
  @Input() delaySeconds = 5;

  readonly visible = signal(false);

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const delayMs = Math.max(0, this.delaySeconds) * 1000;
    this.timer = setTimeout(() => this.visible.set(true), delayMs);
  }

  ngOnDestroy(): void {
    if (this.timer) clearTimeout(this.timer);
  }

  dismiss(): void {
    this.visible.set(false);
  }
}
